module.exports = __webpack_public_path__ + "static/img/cm-form-icon.7d38c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cm-form-icon.png
// module id = 5r2q
// module chunks = 8